import { isAuthenticated } from "@/routers/router-guardians"
import store from "@/store"

const routes = [
  {
    path: "/dashboard/calendar",
    name: "appointments_calendar",
    component: () => import("@/modules/scheduling/pages/appointment-calendar/AppointmentsCalendar.vue"),
    // Allowlisted users land on calendar v2; the "Classic calendar" link opts out with ?classic=1.
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, (guard) => {
        if (guard !== undefined) return next(guard)
        if (store.getters["me/allowShowCalendarV2"] && !to.query.classic) {
          return next({ name: "appointments_calendar_v2", query: to.query })
        }
        return next()
      })
    }
  },
  {
    path: "/dashboard/calendar/v2",
    name: "appointments_calendar_v2",
    component: () => import("@/modules/scheduling/pages/appointment-calendar-v2/AppointmentsCalendarV2.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  }
]

export default routes
